import {makeAutoObservable} from "mobx";

class NoEditStore {
    isOpen = false;
    mode = "locked";

    constructor() {
        makeAutoObservable(this);
    }

    open(mode) {
        this.isOpen = true;
        this.mode = mode;
    }

    close() {
        this.isOpen = false;
    }
}

export const noEditStore = new NoEditStore();